import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40599120")

_pushScopeId("data-v-40599120")
const _hoisted_1 = { class: "esri-widget locationTransportation" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "head" }, [
  /*#__PURE__*/_createVNode("span", { class: "title" }, "Manage Event Locations")
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Locations")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Transportation Points")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("View Report")
const _hoisted_7 = {
  ref: "locationFeatureTableRef",
  class: "featureTable"
}
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Check")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Synchronize")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_14 = {
  ref: "transportationFeatureTableRef",
  class: "featureTable"
}
const _hoisted_15 = { class: "buttons" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Check")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Unassign")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Assign")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Synchronize")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_23 = { class: "imported" }
const _hoisted_24 = /*#__PURE__*/_createVNode("h4", null, "Last Import Summary", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = {
  ref: "reportFeatureTableRef",
  class: "featureTable"
}
const _hoisted_27 = { class: "buttons" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_30 = { slot: "header" }
const _hoisted_31 = { slot: "content" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "Are you sure?", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_41 = { slot: "header" }
const _hoisted_42 = { slot: "content" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "layer" }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { class: "layer" }
const _hoisted_47 = { key: 4 }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Append Data to Layer ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Overwrite Layer ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_53 = { slot: "header" }
const _hoisted_54 = { slot: "content" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("span", null, "Are you sure ?", -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Assign Checkpoint", -1)
const _hoisted_62 = { slot: "content" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Assign")
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Unassign Checkpoint(s)", -1)
const _hoisted_67 = { slot: "content" }
const _hoisted_68 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("span", null, "Are you sure ?", -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Unassign")
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Synchronize", -1)
const _hoisted_73 = { slot: "content" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Refresh")
const _hoisted_77 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Synchronize")
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { slot: "header" }, "Export", -1)
const _hoisted_80 = { slot: "content" }
const _hoisted_81 = /*#__PURE__*/_createVNode("span", null, "Do you want to export ?", -1)
const _hoisted_82 = /*#__PURE__*/_createTextVNode("All items from the table ")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Only the selected item(s) ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Export")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_tab_title = _resolveComponent("calcite-tab-title")
  const _component_calcite_tab_nav = _resolveComponent("calcite-tab-nav")
  const _component_calcite_button = _resolveComponent("calcite-button")
  const _component_calcite_tab = _resolveComponent("calcite-tab")
  const _component_calcite_tabs = _resolveComponent("calcite-tabs")
  const _component_calcite_modal = _resolveComponent("calcite-modal")
  const _component_calcite_radio_button = _resolveComponent("calcite-radio-button")
  const _component_calcite_label = _resolveComponent("calcite-label")
  const _component_calcite_radio_button_group = _resolveComponent("calcite-radio-button-group")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_calcite_tabs, null, {
        default: _withId(() => [
          _createVNode(_component_calcite_tab_nav, { slot: "tab-nav" }, {
            default: _withId(() => [
              _createVNode(_component_calcite_tab_title, { active: "" }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_calcite_tab_title, null, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              (_ctx.report)
                ? (_openBlock(), _createBlock(_component_calcite_tab_title, { key: 0 }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_calcite_tab, { active: "" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_7, null, 512),
              _createVNode("div", _hoisted_8, [
                (_ctx.locationTableSize.size > 0 && _ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 0,
                      "icon-end": "trash",
                      onClick: _cache[1] || (_cache[1] = $event => {_ctx.title = 'Locations'; _ctx.showDeleteModal()}),
                      color: "red",
                      style: {"margin-right":"10px"},
                      disabled: _ctx.locationSelectedItems.size == 0,
                      title: "Delete selected feature(s)"
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 1,
                      "icon-end": "check",
                      onClick: _cache[2] || (_cache[2] = $event => {_ctx.checkLocations();}),
                      style: {"margin-right":"10px"},
                      title: "Check data validation",
                      disabled:  _ctx.locationTableSize.size == 0
                    }, {
                      default: _withId(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 2,
                      "icon-end": "download",
                      onClick: _cache[3] || (_cache[3] = $event => (_ctx.geteRebusData('Locations'))),
                      style: {"margin-right":"10px"},
                      title: "Synchronize and import data"
                    }, {
                      default: _withId(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 3,
                      "icon-end": "export",
                      onClick: _cache[4] || (_cache[4] = $event => {_ctx.showExportModal(); _ctx.exportedData = 'Locations'}),
                      style: {"margin-right":"10px"},
                      title: "Export and download data",
                      disabled:  _ctx.locationTableSize.size == 0
                    }, {
                      default: _withId(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 4,
                      "icon-end": "import",
                      onClick: _cache[5] || (_cache[5] = $event => {_ctx.checkLocationLayers(); _ctx.title = 'Locations'}),
                      title: "Import data in layer"
                    }, {
                      default: _withId(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_calcite_tab, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_14, null, 512),
              _createVNode("div", _hoisted_15, [
                (_ctx.transportationTableSize.size > 0 && _ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 0,
                      "icon-end": "trash",
                      onClick: _cache[6] || (_cache[6] = $event => {_ctx.title = 'Transportation Points'; _ctx.showDeleteModal()}),
                      color: "red",
                      style: {"margin-right":"10px"},
                      disabled: _ctx.transportationSelectedItems.size == 0,
                      title: "Delete selected feature(s)"
                    }, {
                      default: _withId(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 1,
                      "icon-end": "check",
                      onClick: _cache[7] || (_cache[7] = $event => (_ctx.checkTransportationPoints())),
                      style: {"margin-right":"10px"},
                      title: "Check data validation",
                      disabled: _ctx.transportationTableSize.size == 0
                    }, {
                      default: _withId(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 2,
                      "icon-end": "unlink",
                      onClick: _cache[8] || (_cache[8] = $event => (_ctx.showUnassignModal())),
                      style: {"margin-right":"10px"},
                      class: {'clickable': _ctx.isUnassignable},
                      title: "UnAssign checkpoint(s)"
                    }, {
                      default: _withId(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 3,
                      "icon-end": "link",
                      onClick: _cache[9] || (_cache[9] = $event => {_ctx.showAssignModal(); _ctx.showFT = true}),
                      style: {"margin-right":"10px"},
                      class: {'clickable': _ctx.isAssignable},
                      title: "Assign a checkpoint"
                    }, {
                      default: _withId(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 4,
                      "icon-end": "download",
                      onClick: _cache[10] || (_cache[10] = $event => (_ctx.geteRebusData('Transportations'))),
                      style: {"margin-right":"10px"},
                      title: "Synchronize and import data"
                    }, {
                      default: _withId(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 5,
                      "icon-end": "export",
                      onClick: _cache[11] || (_cache[11] = $event => {_ctx.showExportModal(); _ctx.exportedData = 'Transportation Points'}),
                      style: {"margin-right":"10px"},
                      title: "Export and download data",
                      disabled: _ctx.transportationTableSize.size == 0
                    }, {
                      default: _withId(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 6,
                      "icon-end": "import",
                      onClick: _cache[12] || (_cache[12] = $event => {_ctx.checkTransportationLayers(); _ctx.title = 'Transportation Points'}),
                      title: "Import data in layer"
                    }, {
                      default: _withId(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_calcite_tab, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("span", null, "Imported item(s) : " + _toDisplayString(_ctx.itemsImported.length), 1),
                _hoisted_25,
                _createVNode("span", null, "Item(s) not imported : " + _toDisplayString(_ctx.itemsNotImported.length), 1)
              ]),
              _createVNode("div", _hoisted_26, null, 512),
              _createVNode("div", _hoisted_27, [
                (_ctx.reportTableSize.size > 0 && _ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 0,
                      "icon-end": "trash",
                      onClick: _cache[13] || (_cache[13] = $event => {_ctx.title = 'Imported Locations'; _ctx.showDeleteModal()}),
                      color: "red",
                      style: {"margin-right":"10px"},
                      title: "Delete selected feature(s)",
                      disabled: _ctx.reportSelectedItems.size == 0
                    }, {
                      default: _withId(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isEditor)
                  ? (_openBlock(), _createBlock(_component_calcite_button, {
                      key: 1,
                      "icon-end": "export",
                      onClick: _cache[14] || (_cache[14] = $event => {_ctx.showExportModal(); _ctx.exportedData = 'Report'}),
                      title: "Export and download data",
                      disabled: _ctx.reportTableSize.size == 0
                    }, {
                      default: _withId(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "deleteModal"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_30, "Delete " + _toDisplayString(_ctx.title), 1),
        _createVNode("div", _hoisted_31, [
          (_ctx.title == 'Locations')
            ? (_openBlock(), _createBlock("span", _hoisted_32, "You are going to delete " + _toDisplayString(_ctx.locationSelectedItems.size) + " features.", 1))
            : _createCommentVNode("", true),
          (_ctx.title == 'Transportation Points')
            ? (_openBlock(), _createBlock("span", _hoisted_33, " You are going to delete " + _toDisplayString(_ctx.transportationSelectedItems.size) + " features.", 1))
            : _createCommentVNode("", true),
          (_ctx.title == 'Imported Locations')
            ? (_openBlock(), _createBlock("span", _hoisted_34, " You are going to delete " + _toDisplayString(_ctx.reportSelectedItems.size) + " features.", 1))
            : _createCommentVNode("", true),
          _hoisted_35,
          _hoisted_36
        ]),
        _createVNode(_component_calcite_button, {
          slot: "back",
          color: "light",
          onClick: _cache[15] || (_cache[15] = $event => (_ctx.hideDeleteModal()))
        }, {
          default: _withId(() => [
            _hoisted_37
          ]),
          _: 1
        }),
        (_ctx.title == 'Locations')
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 0,
              slot: "primary",
              color: "red",
              onClick: _cache[16] || (_cache[16] = $event => {_ctx.hideDeleteModal(); _ctx.onRemoveLocation()}),
              title: "Delete feature(s)"
            }, {
              default: _withId(() => [
                _hoisted_38
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.title == 'Transportation Points')
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 1,
              slot: "primary",
              color: "red",
              onClick: _cache[17] || (_cache[17] = $event => {_ctx.hideDeleteModal(); _ctx.onRemoveTransportation()}),
              title: "Delete feature(s)"
            }, {
              default: _withId(() => [
                _hoisted_39
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.title == 'Imported Locations')
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 2,
              slot: "primary",
              color: "red",
              onClick: _cache[18] || (_cache[18] = $event => {_ctx.hideDeleteModal(); _ctx.onRemoveBadLocation()}),
              title: "Delete feature(s)"
            }, {
              default: _withId(() => [
                _hoisted_40
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "importModal"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_41, "Import " + _toDisplayString(_ctx.title), 1),
        _createVNode("div", _hoisted_42, [
          (_ctx.title == 'Locations' && _ctx.locationLayers.length == 0)
            ? (_openBlock(), _createBlock("span", _hoisted_43, "No layer available. Please add a point layer."))
            : _createCommentVNode("", true),
          (!_ctx.showFT && _ctx.title == 'Locations')
            ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.locationLayers, (layer) => {
                return (_openBlock(), _createBlock("div", _hoisted_44, [
                  _createVNode(_component_calcite_button, {
                    appearance: "transparent",
                    onClick: $event => {_ctx.showFT = true; _ctx.showImportFeatureTable(layer)}
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(layer.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 256))
            : _createCommentVNode("", true),
          (_ctx.title == 'Transportation Points' && _ctx.transportationLayers.length == 0)
            ? (_openBlock(), _createBlock("span", _hoisted_45, "No layer available. Please add a point layer."))
            : (!_ctx.showFT && _ctx.title == 'Transportation Points')
              ? (_openBlock(true), _createBlock(_Fragment, { key: 3 }, _renderList(_ctx.transportationLayers, (layer) => {
                  return (_openBlock(), _createBlock("div", _hoisted_46, [
                    _createVNode(_component_calcite_button, {
                      appearance: "transparent",
                      onClick: $event => {_ctx.showFT = true; _ctx.showImportFeatureTable(layer)}
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(layer.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 256))
              : _createCommentVNode("", true),
          _createVNode("div", {
            ref: "importFeatureTableRef",
            class: {'modalFeatureTable' : _ctx.showFT}
          }, null, 2),
          (_ctx.showFT)
            ? (_openBlock(), _createBlock("div", _hoisted_47, [
                _createVNode(_component_calcite_radio_button_group, null, {
                  default: _withId(() => [
                    _createVNode(_component_calcite_label, { layout: "inline" }, {
                      default: _withId(() => [
                        _createVNode(_component_calcite_radio_button, {
                          onClick: _cache[19] || (_cache[19] = $event => {_ctx.appendData = true; _ctx.overwriteData = false}),
                          checked: ""
                        }),
                        _hoisted_48
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_calcite_label, { layout: "inline" }, {
                      default: _withId(() => [
                        _createVNode(_component_calcite_radio_button, {
                          onClick: _cache[20] || (_cache[20] = $event => {_ctx.overwriteData = true; _ctx.appendData = false})
                        }),
                        _hoisted_49
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.showFT)
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 0,
              slot: "back",
              color: "light",
              onClick: _cache[21] || (_cache[21] = $event => {_ctx.showFT = false; _ctx.hideImportModal(); _ctx.size = 0}),
              title: "Close the modal"
            }, {
              default: _withId(() => [
                _hoisted_50
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showFT)
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 1,
              slot: "back",
              color: "light",
              onClick: _cache[22] || (_cache[22] = $event => {_ctx.showFT = false; _ctx.hideImportFeatureTable()}),
              title: "Back to layer selection"
            }, {
              default: _withId(() => [
                _hoisted_51
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[23] || (_cache[23] = $event => {_ctx.showFT = false; _ctx.hideImportFeatureTable(); _ctx.hideImportModal(); _ctx.importData(_ctx.layer);}),
          title: "Import data in layer",
          disabled: _ctx.importTableSize.size == 0
        }, {
          default: _withId(() => [
            _hoisted_52
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "overwriteModal"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_53, "Overwrite " + _toDisplayString(_ctx.title), 1),
        _createVNode("div", _hoisted_54, [
          (_ctx.title == 'Locations')
            ? (_openBlock(), _createBlock("span", _hoisted_55, "You are going to delete " + _toDisplayString(_ctx.locationTableSize.size) + " features and replace them by " + _toDisplayString(_ctx.totalFeatures) + " features.", 1))
            : _createCommentVNode("", true),
          (_ctx.title == 'Transportation Points')
            ? (_openBlock(), _createBlock("span", _hoisted_56, " Your are going to delete " + _toDisplayString(_ctx.transportationTableSize.size) + " features and replace them by " + _toDisplayString(_ctx.totalFeatures) + " features.", 1))
            : _createCommentVNode("", true),
          _hoisted_57,
          _hoisted_58
        ]),
        _createVNode(_component_calcite_button, {
          slot: "back",
          color: "light",
          onClick: _cache[24] || (_cache[24] = $event => {_ctx.hideOverwriteModal(); _ctx.showImportModal()}),
          title: "Close the modal"
        }, {
          default: _withId(() => [
            _hoisted_59
          ]),
          _: 1
        }),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[25] || (_cache[25] = $event => {_ctx.hideOverwriteModal(); _ctx.validation = true; _ctx.importData(_ctx.layer);}),
          title: "Import data in layer",
          disabled: _ctx.importTableSize.size == 0
        }, {
          default: _withId(() => [
            _hoisted_60
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "assignModal"
    }, {
      default: _withId(() => [
        _hoisted_61,
        _createVNode("div", _hoisted_62, [
          _createVNode("div", {
            ref: "assignFeatureTableRef",
            class: {'modalFeatureTable' : _ctx.showFT}
          }, null, 2),
          (_ctx.wrongTPs)
            ? (_openBlock(), _createBlock("span", _hoisted_63, "The transportation points you have selected don't all have the same ParentLocationID. Please re-select others with the same ParentLocationID"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_calcite_button, {
          slot: "back",
          color: "light",
          onClick: _cache[26] || (_cache[26] = $event => {_ctx.showFT = false; _ctx.hideAssignModal()}),
          title: "Close the modal"
        }, {
          default: _withId(() => [
            _hoisted_64
          ]),
          _: 1
        }),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[27] || (_cache[27] = $event => {_ctx.showFT = false; _ctx.hideAssignModal(); _ctx.assignCheckPoint()}),
          title: "Assign a checkpoint",
          disabled: _ctx.assignTableSize.size != 1
        }, {
          default: _withId(() => [
            _hoisted_65
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "unassignModal"
    }, {
      default: _withId(() => [
        _hoisted_66,
        _createVNode("div", _hoisted_67, [
          _createVNode("span", null, "You are going to unassign one or more checkpoint to " + _toDisplayString(_ctx.transportationSelectedItems.size) + " transportation points.", 1),
          _hoisted_68,
          _hoisted_69
        ]),
        _createVNode(_component_calcite_button, {
          slot: "back",
          color: "light",
          onClick: _cache[28] || (_cache[28] = $event => (_ctx.hideUnassignModal())),
          title: "Close the modal"
        }, {
          default: _withId(() => [
            _hoisted_70
          ]),
          _: 1
        }),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[29] || (_cache[29] = $event => {_ctx.hideUnassignModal(); _ctx.unassignCheckPoint()}),
          title: "UnAssign checkpoint(s)"
        }, {
          default: _withId(() => [
            _hoisted_71
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "syncModal"
    }, {
      default: _withId(() => [
        _hoisted_72,
        _createVNode("div", _hoisted_73, [
          _createVNode("div", {
            ref: "syncFeatureTableRef",
            class: {'modalFeatureTable' : _ctx.showFT}
          }, null, 2)
        ]),
        _createVNode(_component_calcite_button, {
          slot: "back",
          color: "light",
          onClick: _cache[30] || (_cache[30] = $event => (_ctx.hideSyncModal())),
          title: "Close the modal"
        }, {
          default: _withId(() => [
            _hoisted_74
          ]),
          _: 1
        }),
        (_ctx.isEditor)
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 0,
              slot: "primary",
              color: "red",
              "icon-end": "trash",
              onClick: _cache[31] || (_cache[31] = $event => (_ctx.deleteeRebusData())),
              title: "Delete data",
              style: {"margin-right":"10px"}
            }, {
              default: _withId(() => [
                _hoisted_75
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEditor)
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 1,
              slot: "primary",
              "icon-end": "refresh",
              onClick: _cache[32] || (_cache[32] = $event => (_ctx.refresheRebusData())),
              title: "Refresh data",
              style: {"margin-right":"10px"}
            }, {
              default: _withId(() => [
                _hoisted_76
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEditor)
          ? (_openBlock(), _createBlock(_component_calcite_button, {
              key: 2,
              slot: "primary",
              "icon-end": "export",
              onClick: _cache[33] || (_cache[33] = $event => {_ctx.showExportModal(); _ctx.exportedData = 'Synchronize'}),
              title: "Export and download data",
              disabled: _ctx.syncTableSize.size == 0,
              style: {"margin-right":"10px"}
            }, {
              default: _withId(() => [
                _hoisted_77
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[34] || (_cache[34] = $event => (_ctx.hideSyncModal())),
          title: "Synchronize and import the data",
          disabled: _ctx.syncSelectedItems.size == 0
        }, {
          default: _withId(() => [
            _hoisted_78
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_calcite_modal, {
      width: "m",
      active: "false",
      "disable-close-button": "",
      "disable-outside-close": "",
      ref: "exportModal"
    }, {
      default: _withId(() => [
        _hoisted_79,
        _createVNode("div", _hoisted_80, [
          _hoisted_81,
          _createVNode(_component_calcite_radio_button_group, { style: {"margin-left":"25%","margin-top":"1%"} }, {
            default: _withId(() => [
              _createVNode(_component_calcite_label, { layout: "inline" }, {
                default: _withId(() => [
                  _createVNode(_component_calcite_radio_button, {
                    onClick: _cache[35] || (_cache[35] = $event => (_ctx.exportType = 'Layer')),
                    checked: ""
                  }),
                  _hoisted_82
                ]),
                _: 1
              }),
              _createVNode(_component_calcite_label, { layout: "inline" }, {
                default: _withId(() => [
                  _createVNode(_component_calcite_radio_button, {
                    onClick: _cache[36] || (_cache[36] = $event => (_ctx.exportType = 'Selected'))
                  }),
                  _hoisted_83
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_calcite_button, {
          slot: "back",
          color: "light",
          onClick: _cache[37] || (_cache[37] = $event => (_ctx.hideExportModal())),
          title: "Close the modal"
        }, {
          default: _withId(() => [
            _hoisted_84
          ]),
          _: 1
        }),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "blue",
          onClick: _cache[38] || (_cache[38] = $event => {_ctx.hideExportModal(); _ctx.exportData()}),
          title: "Export and download data"
        }, {
          default: _withId(() => [
            _hoisted_85
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
})